import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import axios from '../../../../axios-instance';

import './PromoterAnalytics.sass';
import { getHeaders } from '../../../../helpers/getHeaders';
import NewLoader from '../../../../components/NewLoader/NewLoader';
import debounce from 'lodash.debounce';
import { fetchAnalyticsData } from '../../../../helpers/fetchAnalyticsData';

const initAnalyticsData = {
  tikTokPixelId: '',
  googleAnalytics4MeasurmentId: '',
  googleAdwordsConversionId: '',
  googleAdwordsConversionLabel: '',
  googleTagManagerId: '',
  facebookPixelId: '',
  facebookAccessToken: '',
}

export const PromoterAnalytics = ({ token }) => {
  const [analyticsData, setAnalyticsData] = useState(initAnalyticsData);
  const [isDataLoading, setDataLoading] = useState(true);
  const [isValidGoogleTagId, setValidGoogleTagId] = useState(true);
  const [isButtonDisabled, setButtonDisabled] = useState(true);

  const getAnalyticsData = async () => {
    setDataLoading(true);
    try {
      const data = await fetchAnalyticsData(token);

      if (data) {
        setAnalyticsData(data);
      }
    } finally {
      setDataLoading(false);
    }
  }

  const updateAmalyticsData = async () => {
    setDataLoading(true);

    try {
      const res = await axios.put(
        `/PromoterAnalyticsInfo`,
        analyticsData,
        {headers: getHeaders(token)}
      );

      if (res.data) {
        toast.success('Analytics data is updated successfully')
      }

      if (!res.data) {
        throw new Error(res.data.errorMessage);
      }
    } catch (error) {
      const message = `Analytics data not updated. ${error}` || 'Analytics data not updated'
      toast.error(message);
    } finally {
      setDataLoading(false);
    }
  };

  const validationGoogleTagId = async (GTagID) => {
    axios
      .get(`/PromoterAnalyticsInfo/GoogleTagManagerIdValidation/${GTagID}`, { headers: getHeaders(token) })
      .then(async (response) => {
        if (response.data.isSuccess) {
          setValidGoogleTagId(response.data.result);
          setButtonDisabled(!response.data.result);
        }
      });
  };

  const debounceFn = useCallback(debounce(validationGoogleTagId, 500), []);

  const onChangeAnalyticsData = (key, value) => {
    setAnalyticsData(prev => ({
      ...prev,
      [key]: value,
    }));

    if (key === 'googleTagManagerId') {
      debounceFn(value);
    } else {
      setButtonDisabled(false);
    }
  };

  useEffect(() => {
    getAnalyticsData();
  }, []);

  if (isDataLoading) {
    return <NewLoader />;
  }

  return (
    <section className="promoter-analytics">
      <div className="promoter-analytics__data-container">
        <div className="add-event__block">
          <label>Google Tag Manager ID</label>
          <input
            type="text"
            name="googleTagManagerId"
            minLength="3"
            maxLength="500"
            placeholder="Enter Google Tag Manager ID"
            value={analyticsData.googleTagManagerId}
            onChange={(e) => onChangeAnalyticsData('googleTagManagerId', e.target.value)}
          />
          {!isValidGoogleTagId && (
            <p className="promoter-analytics__error-message">
              Google Tag Manager ID is invalid
            </p>
          )}
        </div>

        <div className="add-event__block">
          <label>Google Analytics 4 measurement ID</label>
          <input
            type="text"
            name="googleAnalytics4MeasurmentId"
            minLength="3"
            maxLength="500"
            placeholder="Enter Google Analytics 4 measurement ID"
            value={analyticsData.googleAnalytics4MeasurmentId}
            onChange={(e) => onChangeAnalyticsData('googleAnalytics4MeasurmentId', e.target.value)}
          />
        </div>

        <div className="add-event__block">
          <label>Facebook pixel ID</label>
          <input
            type="text"
            name="facebookPixelId"
            minLength="3"
            maxLength="500"
            placeholder="Enter Facebook pixel ID"
            value={analyticsData.facebookPixelId}
            onChange={(e) => onChangeAnalyticsData('facebookPixelId', e.target.value)}
          />
        </div>
        <div className="add-event__block">
          <label>TikTok pixel ID</label>
          <input
            type="text"
            name="tikTokPixelId"
            minLength="3"
            maxLength="500"
            placeholder="Enter TikTok pixel ID"
            value={analyticsData.tikTokPixelId}
            onChange={(e) => onChangeAnalyticsData('tikTokPixelId', e.target.value)}
          />
        </div>

        <div className="add-event__block">
          <label>Google Adwords Conversion ID</label>
          <input
            type="text"
            name="googleAdwordsConversionId"
            minLength="3"
            maxLength="500"
            placeholder="Enter Google Adwords Conversion ID"
            value={analyticsData.googleAdwordsConversionId}
            onChange={(e) => onChangeAnalyticsData('googleAdwordsConversionId', e.target.value)}
          />
        </div>

        <div className="add-event__block">
          <label>Google Adwords Conversion Label</label>
          <input
            type="text"
            name="googleAdwordsConversionLabel"
            minLength="3"
            maxLength="500"
            placeholder="Enter Google Adwords Conversion ID"
            value={analyticsData.googleAdwordsConversionLabel}
            onChange={(e) => onChangeAnalyticsData('googleAdwordsConversionLabel', e.target.value)}
          />
        </div>
      </div>

      <button
        type='button'
        className='btn-primary promoter-analytics__save-btn'
        onClick={updateAmalyticsData}
        disabled={isButtonDisabled || !isValidGoogleTagId}
      >
        Save
      </button>
    </section>
  )
}

const mapStateToProps = ({ auth }) => ({
  token: auth.user.token,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PromoterAnalytics)
);
